module.exports = __webpack_public_path__ + "img/home_banner.87afcc6c.png";